import { Message } from "../models/Message";
import React, { FC } from "react";
import { areDatesDifferent } from "../utilities/DateUtil";
import ChatMessage from "./ChatMessage";

interface ChatMessagesProps {
  messages: Message[];
}

const ChatMessages: FC<ChatMessagesProps> = ({
  messages,
}: ChatMessagesProps) => {
  let datesAreDifferent: boolean = true;
  let previousDate: string = "";

  return (
    <>
      {messages.map((message: Message, index: number): React.JSX.Element => {
        datesAreDifferent = areDatesDifferent(
          previousDate,
          message.isoCreatedAt,
        );

        previousDate = message.isoCreatedAt;

        const isAdmin: boolean = message.senderType === "ADMIN";

        return (
          <ChatMessage
            key={`chat-message-${index}`}
            datesAreDifferent={datesAreDifferent}
            index={index}
            isAdmin={isAdmin}
            message={message}
          />
        );
      })}
    </>
  );
};

export default ChatMessages;
